<template>
  <div class="main">
    <!-- Scanner Bridge Not Connected Alert -->
    <b-alert
      v-if="!isBridgeConnected"
      variant="warning"
      show
      class="mb-3 scanner-bridge-alert"
    >
      <div class="d-flex align-items-start">
        <feather-icon icon="AlertCircleIcon" size="20" class="mr-2 mt-1" />
        <div class="flex-grow-1">
          <strong>{{ $t("scanner.bridge-not-connected") }}</strong>
          <p class="mb-2 mt-1">{{ $t("scanner.please-download-bridge") }}</p>
          <b-button
            v-if="scannerBridgeDownloadUrl"
            variant="primary"
            size="sm"
            :href="scannerBridgeDownloadUrl"
            target="_blank"
            class="mt-1"
          >
            <feather-icon icon="DownloadIcon" size="14" class="mr-50" />
            {{ $t("scanner.download-scanner-bridge") }}
          </b-button>
        </div>
      </div>
    </b-alert>

    <div
      class="dropzone-container"
      @dragover="dragover"
      @dragleave="dragleave"
      @drop="drop"
    >
      <input
        type="file"
        name="file"
        id="fileInput"
        class="hidden-input"
        @change="onChange"
        ref="file"
        accept=".pdf,.jpg,.jpeg,.png"
      />
      <label for="fileInput" class="file-label">
        <div v-if="isDragging">Release to drop files here.</div>
        <div v-else>
          <b-img class="mb-2" :src="scannerImg" width="100" height="100" />
          <h4>Drag and Drop Scanned Images Here</h4>
        </div>
      </label>
    </div>
  </div>
</template>
<script>
import { BImg, BAlert, BButton } from "bootstrap-vue";
import ScannerIllustration from "@/assets/images/illustration/scanner.png";

export default {
  components: {
    BImg,
    BAlert,
    BButton,
  },

  data() {
    return {
      isDragging: false,
      files: [],
      loading: false,
      params: {
        form: {},
        path: "",
      },
      scannerImg: ScannerIllustration,
      isBridgeConnected: false,
      scannerBridgeDownloadUrl: "", // Will be provided later
      bridgeCheckInterval: null,
    };
  },
  props: [
    "getAttachments",
    "attachableId",
    "attachableType",
    "type",
    "patientCardId",
  ],
  mounted() {
    console.log('DropFile mounted - checking scanner bridge connection...');
    this.checkBridgeConnection();
    // Check bridge connection every 5 seconds
    this.bridgeCheckInterval = setInterval(() => {
      this.checkBridgeConnection();
    }, 5000);
  },
  beforeDestroy() {
    if (this.bridgeCheckInterval) {
      clearInterval(this.bridgeCheckInterval);
    }
  },
  methods: {
    async checkBridgeConnection() {
      try {
        // Try to connect to the scanner bridge (assuming it runs on localhost:8765)
        const response = await fetch('http://localhost:8765/status', {
          method: 'GET',
        });
        this.isBridgeConnected = response.ok;
        console.log('Scanner bridge connected:', this.isBridgeConnected);
      } catch (error) {
        this.isBridgeConnected = false;
        console.log('Scanner bridge NOT connected - alert should show');
      }
    },
    submitClinicAttachment() {
      this.loading = true;
      let data = new FormData();
      this.createMode = true;
      data.append("attachment", this.$refs.file.files[0]);
      data.append("patient_card_id", this.patientCardId);

      for (let item in this.errorForm) {
        this.errorForm[item] = "";
        if (this.EditForm[item] == "" || this.EditForm[item] == null)
          delete this.EditForm[item];
      }

      if (this.createMode) {
        (this.params.form = data),
          (this.params.path = `/clinic-attachment`),
          this.$store
            .dispatch("create", this.params)
            .then((response) => {
              this.getAttachments();
              this.loading = false;
            })
            .catch((error) => {
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      }
    },
    onChange() {
      if (this.type === "CLINIC") {
        return this.submitClinicAttachment();
      }
      this.loading = true;
      let data = new FormData();
      this.createMode = true;
      data.append("attachment", this.$refs.file.files[0]);
      data.append("attachable_id", this.patientCardId ?? this.attachableId);
      data.append("attachable_type", this.attachableType);
      data.append("type", this.type);

      for (let item in this.errorForm) {
        this.errorForm[item] = "";
        if (this.EditForm[item] == "" || this.EditForm[item] == null)
          delete this.EditForm[item];
      }

      if (this.createMode) {
        (this.params.form = data),
          (this.params.path = `/attachment`),
          this.$store
            .dispatch("create", this.params)
            .then((response) => {
              this.getAttachments();
              this.loading = false;
            })
            .catch((error) => {
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      }
    },
    dragover(e) {
      e.preventDefault();
      this.isDragging = true;
    },
    dragleave() {
      this.isDragging = false;
    },
    drop(e) {
      e.preventDefault();
      this.$refs.file.files = e.dataTransfer.files;
      this.onChange();
      this.isDragging = false;
    },
  },
};
</script>
<style>
.main {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.scanner-bridge-alert {
  max-width: 600px;
  width: 100%;
  text-align: left;
}

.dropzone-container {
  padding: 4rem;
  background: #f7fafc;
  border: 1px solid #e2e8f0;
}

.hidden-input {
  opacity: 0;
  overflow: hidden;
  position: absolute;
  width: 1px;
  height: 1px;
}

.file-label {
  font-size: 20px;
  display: block;
  cursor: pointer;
}

.preview-container {
  display: flex;
  margin-top: 2rem;
}

.preview-card {
  display: flex;
  border: 1px solid #a2a2a2;
  padding: 5px;
  margin-left: 5px;
}

.preview-img {
  width: 50px;
  height: 50px;
  border-radius: 5px;
  border: 1px solid #a2a2a2;
  background-color: #a2a2a2;
}
</style>
